import OnboardingWelcomeModule from './OnboardingWelcomeModule'

export default OnboardingWelcomeModule
